import { render, staticRenderFns } from "./SidebarCreateReportComponent.vue?vue&type=template&id=8ad0f028&scoped=true&"
import script from "./SidebarCreateReportComponent.vue?vue&type=script&lang=js&"
export * from "./SidebarCreateReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarCreateReportComponent.vue?vue&type=style&index=0&id=8ad0f028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad0f028",
  null
  
)

export default component.exports